import { getMchList } from './api';
import { Coupon } from './type';
import { cloneDeep } from 'lodash-es';

const LARGE_PAGE_SIZE = 6;
const SMALL_PAGE_SIZE = 3;
/** 获取分割位置 */
export const getPageLimit = (count) => {
  const pageLimit = LARGE_PAGE_SIZE;
  if (count <= pageLimit) {
    return SMALL_PAGE_SIZE;
  }
  return pageLimit;
};

/** 补充空数据 */
export const insertEmpty = <T>(arr: T[], targetNumber: number): T[] => {
  if (arr.length === 0) {
    return [];
  }
  const emptyArr: T[] = [];
  for (let i = 0; i < targetNumber; i++) {
    emptyArr.push(getEmptyCoupon() as unknown as T);
  }
  return [...arr, ...emptyArr];
};

/** 获取空优惠券对象 */
export const getEmptyCoupon = (key?: number): Coupon => ({
  couponId: Math.floor(Math.random() * 10000 * (key || 1)) * Math.floor(Math.random() * 10000),
  isEmpty: true,
  isPlayAni: false,
  isGet: false,
} as unknown as Coupon);

/** 获取需要补充的数量 */
export const getEmptyNumber = (total, pageSize = SMALL_PAGE_SIZE) => {
  let emptyNumber = Math.ceil(total / pageSize) * pageSize - total;
  if (emptyNumber > SMALL_PAGE_SIZE) {
    emptyNumber = emptyNumber - SMALL_PAGE_SIZE;
  }
  /** 最后一页的数量判断 最少补充到3个 最多补充到6个 */
  const realEmptyNumber = emptyNumber === SMALL_PAGE_SIZE ? 0 : emptyNumber;
  return realEmptyNumber;
};

/** 获取热门推荐列表 */
export const getHotCouponList = (couponList: Coupon[], customPageSize?: number) => {
  // const couponList: Coupon[] = await getHotList();

  const clonedCouponList: Coupon[] = cloneDeep(couponList);
  /** 每页个数 */
  const pageSize = customPageSize || getPageLimit(clonedCouponList.length);
  /** 券总数 */
  const couponCount = clonedCouponList.length;
  /** 需要补充空占位的个数 */
  /** 最后一页的数量判断 最少补充到3个 最多补充到6个 */
  const realEmptyNumber = getEmptyNumber(couponCount, pageSize);
  /** 补充空占后的数据 */
  const fullList = insertEmpty(clonedCouponList, realEmptyNumber);
  /** 总页数 */
  const totalPageNumber = Math.ceil(fullList.length / pageSize);

  return {
    fullList,
    pageSize,
    totalPageNumber,
  };
};

/** chunk 数组分片 */
export const chunk = <T>(array: Array<T>, size = 6): T[][] =>  {
  let index = 0;
  const newArr: T[][] = [];
  while (index < array.length) {
    newArr.push(array.slice(index, (index += size)));
  }
  return newArr;
};

export const getMchIntroductionList = async () => {
  const arr = await getMchList();
  const formatData = arr.map(item => ({
    spLogo: item.spLogo,
    rank: item.rank,
  })).sort((a, b) => Number(b.rank) - Number(a.rank));
  return chunk(formatData, 5);
};

/** 交换数组的位置 */
export const exchangeIndex = (to, from, arr, key) => {
  const index1 = arr.findIndex(item => item[key] === to[key]);
  const index2 = arr.findIndex(item => item[key] === from[key]);
  if (index1 < 0) {
    // eslint-disable-next-line no-param-reassign
    return arr[index2] = to;
  }
  const temp = arr[index1];
  // eslint-disable-next-line no-param-reassign
  arr[index1] = arr[index2];
  // eslint-disable-next-line no-param-reassign
  arr[index2] = temp;
};

export const getCurBusinessName = () => {
  const currentBusinessName = (window as any).__ProjectName || (window as any).__projectName;
  return currentBusinessName;
};
